import { useState, useEffect } from "react";

// Custom hook to debounce a value
interface IUseDebounce {
  value: string;
  delay: number;
  callback?: (...params: any) => void;
}

export const useDebounce = ({ value, delay, callback }: IUseDebounce) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      callback && callback(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return { debouncedValue };
};
